import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarMenuComponent } from './sidebar-menu.component';
import { SidebarMenuElementComponent } from './sidebar-menu-element.component';
import { SharedModule } from '../../core/shared/shared.module';
import { UserblockComponent } from './userblock/userblock.component';
import { UserblockService } from './userblock/userblock.service';
import { ShellModule } from '../shell.module';
import { UnsafeHtmlSanitizerPipe } from './userblock/unsafeHtmlSanitizer.pipe';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [ SidebarMenuComponent ],
  declarations: [SidebarMenuComponent, SidebarMenuElementComponent, UserblockComponent, UnsafeHtmlSanitizerPipe],
  providers: [UserblockService]
})
export class SidebarMenuModule {
}
